import { Euro, Sparkles, Truck, Warehouse } from "lucide-react";

// Mappa del menu super_admin per aree → sottocategorie → pagine.
// Le pagine [ESISTE] puntano agli URL attuali; le [NUOVA] hanno `soon: true` (in costruzione).
export const ADMIN_AREAS = [
  {
    key: "pulizie", label: "Pulizie", icon: Sparkles, color: "#EC4E5B",
    desc: "Giornata, programmazione, strutture, storico.",
    groups: [
      { label: "Oggi", pages: [
        { to: "/admin/gestione", label: "Gestione" },
        { to: "/admin/rientri", label: "Rientri" },
        { to: "/admin/tasklist", label: "Task list" },
        { to: "/admin/stato-video", label: "Stato video" },
        { to: "/admin/tassa-soggiorno", label: "Tassa di soggiorno" },
      ] },
      { label: "Programmazione", pages: [
        { to: "/admin/programmazione/pulizie", label: "Programmazione pulizie" },
        { to: "/admin/programmazione", label: "Programmazione completa (pulizie + consegne)" },
        { to: "/admin/schedule", label: "Pulizie (giornata)" },
        { to: "/admin/prenotazioni", label: "Prenotazioni" },
        { to: "/admin/note-specifiche", label: "Specifiche note" },
      ] },
      { label: "Strutture", pages: [
        { to: "/admin/structures", label: "Strutture" },
        { to: "/admin/access-search", label: "Ricerca accessi" },
      ] },
      { label: "Clienti", pages: [{ key: "clienti-pulizie", label: "Clienti pulizie", soon: true }] },
      { label: "Prodotti magazzino", pages: [{ to: "/admin/materiale", label: "Prodotti per pulire" }] },
      { label: "Storico", pages: [{ to: "/admin/storico", label: "Storico pulizie" }] },
      { label: "Analisi e statistica", pages: [{ to: "/admin/reports", label: "Non conformità pulizie" }] },
    ],
  },
  {
    key: "consegne", label: "Consegne", icon: Truck, color: "#2563EB",
    desc: "Giro del giorno, programmazione, DDT.",
    groups: [
      { label: "Oggi", pages: [{ to: "/logistica", label: "Consegne del giorno" }] },
      { label: "Programmazione", pages: [
        { to: "/admin/programmazione/consegne", label: "Programmazione consegne" },
        { to: "/admin/giri", label: "Giri (mappa)" },
        { to: "/admin/lavanderia", label: "Lavanderia privata" },
        { to: "/admin/stagioni", label: "Estate / Inverno" },
      ] },
      { label: "Strutture", pages: [
        { to: "/admin/structures", label: "Strutture" },
        { to: "/logistica/strutture", label: "Strutture (vista rider)" },
      ] },
      { label: "Clienti", pages: [
        { key: "clienti-biancheria", label: "Clienti biancheria", soon: true },
        { to: "/admin/stagioni", label: "Estate / Inverno" },
      ] },
      { label: "DDT", pages: [
        { to: "/admin/ddt", label: "DDT" },
        { key: "bolle-crea", label: "Bolle di carico e CMR", soon: true },
      ] },
      { label: "Analisi e statistica", pages: [{ key: "stat-consegne", label: "Statistiche consegne", soon: true }] },
    ],
  },
  {
    key: "magazzino", label: "Magazzino", icon: Warehouse, color: "#059669",
    desc: "Sede, magazzinetti, non conformi, forniture.",
    groups: [
      { label: "Magazzino sede", pages: [{ to: "/admin/magazzino-sede", label: "Giacenze sede e carichi" }] },
      { label: "Magazzinetti", pages: [{ to: "/admin/inventory", label: "Magazzinetti nelle case" }] },
      { label: "Non conformi", pages: [
        { to: "/admin/non-conformi", label: "Non conformi" },
        { to: "/admin/storni-dipendenti", label: "Non conformi dipendenti" },
      ] },
      { label: "Ordini", pages: [{ key: "ordini", label: "Ordini clienti", soon: true }] },
      { label: "Personale", pages: [{ to: "/admin/magazzino/personale", label: "Magazzinieri" }] },
      { label: "Forniture", pages: [
        { to: "/admin/products", label: "Catalogo prodotti" },
        { to: "/admin/kits", label: "Kit" },
        { key: "kit-cortesia", label: "Kit cortesia", soon: true },
        { key: "forniture-nostre", label: "Forniture nostre", soon: true },
      ] },
      { label: "Analisi e statistica", pages: [{ to: "/admin/analisi-storni", label: "Statistiche non conformi" }] },
    ],
  },
  {
    key: "amministrazione", label: "Amministrazione", icon: Euro, color: "#1F1F1F",
    desc: "Fatture, dipendenti, clienti, documenti e analisi.",
    groups: [
      { label: "Fatture", pages: [
        { to: "/admin/fatturazione", label: "Fatturazione", lock: true },
        { to: "/admin/standard", label: "Preventivi e contratti", lock: true },
        { to: "/admin/chiusura-mese", label: "Chiusura mese", lock: true },
      ] },
      { label: "Dipendenti", pages: [
        { to: "/admin/users", label: "Utenti", lock: true },
        { to: "/admin/ore-dipendenti", label: "Ore dipendenti", lock: true },
        { to: "/admin/riposi", label: "Riposo dipendenti", lock: true },
        { to: "/admin/report-tempi", label: "Report tempi", lock: true },
      ] },
      { label: "Clienti", pages: [
        { to: "/admin/clienti", label: "Clienti", lock: true },
        { to: "/admin/stagioni", label: "Estate / Inverno" },
      ] },
      { label: "Consegne (archivio documenti)", pages: [
        { to: "/admin/ddt", label: "DDT" },
        { key: "bolle-archivio", label: "Bolle di carico e CMR", soon: true },
      ] },
      { label: "Fornitori", pages: [{ key: "fornitori", label: "Fornitori", soon: true }] },
      { label: "Analisi e statistica", pages: [{ to: "/admin/economics", label: "Economics", lock: true }] },
    ],
  },
];

export const ADMIN_SETTINGS_PAGES = [
  { to: "/admin/azienda", label: "Dati azienda · Claude · Google Tasks" },
  { to: "/admin", label: "Dashboard" },
  { to: "/admin/setup", label: "Setup da completare" },
  { to: "/admin/cestino", label: "Cestino" },
  { to: "/admin/kilo", label: "Kilo AI" },
];

export const pageHref = (p) => p.to || `/admin/in-costruzione/${p.key}`;
export const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const letterOf = (i) => LETTERS[i] || "";
export const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// Schermata di menu «precedente» per un percorso: usata dal tasto ESC.
export function parentMenuFor(pathname) {
  if (pathname === "/admin/home") return null;
  const m = pathname.match(/^\/admin\/home\/([^/]+)(?:\/([^/]+))?$/);
  if (m) return m[2] ? `/admin/home/${m[1]}` : "/admin/home";
  for (const a of ADMIN_AREAS) {
    for (const g of a.groups) {
      if (g.pages.some((p) => pageHref(p) === pathname || (p.to && p.to !== "/admin" && pathname.startsWith(p.to + "/")))) {
        return g.pages.length === 1 ? `/admin/home/${a.key}` : `/admin/home/${a.key}/${slug(g.label)}`;
      }
    }
  }
  return "/admin/home";
}

export function areaForPath(pathname) {
  for (const a of ADMIN_AREAS) {
    for (const g of a.groups) {
      if (g.pages.some((p) => pageHref(p) === pathname || (p.to && p.to !== "/admin" && pathname.startsWith(p.to + "/")))) return a.key;
    }
  }
  return null;
}
